<template>
  <div class="view-submit-bar">
    <div class="view-bar-price">
      <div class="price-total-label fz16">总额:</div>
      <span class="price-total-symbol fz12">￥</span>
      <span class="price-total-value fz20">{{ totalMoney.toFixed(2) }}</span>
    </div>
    <div class="view-bar-button">
      <van-button type="default" :disabled="disabled" block class="book-button fz20" @click="onSubmit">去支付</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-submit-bar",
  props: {
    totalMoney: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async onSubmit() {
      this.$emit("onSubmit");
    }
  }
};
</script>

<style lang="scss" scoped>
.view-submit-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  box-shadow: 0px -10px 15px -10px #999;
  z-index:502;
  .view-bar-price {
    padding-left: 14px;
    width: 64%;
    display: flex;
    align-items: center;
    .price-total-symbol {
      padding-left: 4px;
      color: #820203;
    }
    .price-total-value {
      padding-left: 2px;
      font-weight: bold;
      color: #820203;
    }
  }
  .view-bar-button {
    width: 36%;
    .van-button {
      border: none;
      height: 48px;
      color: #fff;
      text-align: center;
    }
    .book-button {
      background-color: #810102;
    }
  }
}
</style>
